<template>
  <!-- 文献解读列表 -->
  <div class="my-article">
    <div class="cons-flex">
      <div class="cons-item" @click="handleClick(item)" :class="curItem === item.id ? 'cur' : ''"
      v-for="(item, index) in menuList" :key="index">
        {{ item && item.value }}
        <img v-if="curItem === item.id" src="@/assets/images/training/img(6).png" class="img-btm" alt="">
      </div>
    </div>
    <van-list v-model="loading" v-if="!isNone" :finished="finished" finished-text="我是有底线的"
              loading-text="正在加载..." @load="onLoad" class="cons-list">
      <div class="flex-con" v-for="(item, index) in list" :key="index" @click="handleJump(item, index)">
        <div class="left-con">
          <div class="txt1 docu">{{ item && item.title }}</div>
          <div class="txt2">
            <span class="span2">阅读量:{{ item && item.count }}</span>
          </div>
        </div>
        <div class="right-con">
          <img :src="item && item.icon" class="con-cover" alt="">
        </div>
      </div>
    </van-list>
    <div class="search-none" v-else>
      <img src="@/assets/images/home/empty_state_none@2x.png" class="none-img" alt="">
      <div class="none-txt">暂无内容</div>
    </div>
    <returnBack backTxt="home"></returnBack>
  </div>
</template>
<script>
import { getProxyMobile, dictionaryDownList } from '@/api/article'
import withRouteTracking from '@/utils/withRouteTracking'
import returnBack from '@/views/person/components/returnBack.vue'
const UserProfile = {
  name: 'ArticleList',
  data() {
    return {
      curItem: '',
      menuList: [
        {value: '全部', id: ''},
      ],
      list: [],
      loading: false,
      finished: false,
      pageNum: 1,
      pageSize: 10,
      isNone: false,
    }
  },
  components: {
    returnBack
  },
  mounted() {
    window.sessionStorage.removeItem('entrance')
    this.handleDictionaryDownList()
  },
  methods: {
    // 栏目列表
    handleDictionaryDownList() {
      const params = {
        typeCode: 'LITERATURE_SECTION',
        dataStatus: 1
      }
      dictionaryDownList(params).then(res => {
        if (res.code === 0) {
          this.menuList.push(...res.data)
        }
      })
    },
    handleClick(item) {
      if (this.loading) return
      const dom = document.getElementsByClassName('my-article')[0]
      dom.scrollTop = 0
      this.curItem = item.id
      this.pageNum = 1
      this.finished = false
      this.list = []
      this.isNone = false
      this.onLoad()
    },
    onLoad () {
      let params = {
        columnId: this.curItem,
        pageNum: this.pageNum,
        pageSize: this.pageSize
      }
      this.loading = true
      getProxyMobile(params).then(res => {
        if (res.data.list.length < this.pageSize) {
          this.finished = true
        }
        this.list = this.list.concat(res.data.list)
        // 加载状态结束
        this.loading = false
        if (this.list.length <= 0) {
          this.isNone = true
        }
        this.pageNum++
      })
    },
    handleJump (item, index) {
      this.list[index].count++
      this.$router.push({
        path: '/articleDetails',
        query: {
          id: item.id,
          entrance: 11,
          channel: 11
        }
      })
    }
  }
}
// 这块是路由跟踪埋点的功能，具体实现在utils/withRouteTracking.js
export default withRouteTracking(UserProfile)
</script>
<style lang="less" scoped>
.my-article {
  background: #F9F8F7;
  height: 100vh;
  overflow-y: auto;
  width: 100vw;
  padding-top: 60px;
  box-sizing: border-box;
  .cons-flex {
    background: #F9F8F7;
    width: 100%;
    display: flex;
    align-items: center;
    height: 60px;
    position: fixed;
    top: 0px;
    z-index: 99;
    padding: 0 20px;
    box-sizing: border-box;
    .cons-item {
      text-align: center;
      position: relative;
      font-size: 14px;
      color: #656E7F;
      font-weight: 500;
      position: relative;
      height: 42px;
      line-height: 42px;
      white-space: nowrap;
      margin-right: 21px;
      .img-btm {
        width: 24px;
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        bottom: 6px;
      }
      &.cur {
        color: #EB1700;
        font-weight: 600;
      }
    }
  }
  .cons-list {
    background-color: #fff;
    border-radius: 12px;
    margin: 0 12px;
    padding: 15px 0;
    box-sizing: border-box;
  }
  .flex-con {
      display: flex;
      justify-content: space-between;
      padding: 0 12px;
      box-sizing: border-box;
      margin-bottom: 25px;
      align-items: center;

      .right-con {
        width: 110px;
        height: 60px;
        position: relative;
        border-radius: 5px;
        overflow: hidden;

        .con-cover {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }

        .tag-txt {
          position: absolute;
          width: 30px;
          height: 16px;
          font-size: 10px;
          background-color: #6A7481;
          border-radius: 5px;
          left: 0;
          top: 0;
          text-align: center;
          line-height: 16px;
          color: #fff;
          font-size: 10px;
        }
      }

      .left-con {
        .txt1 {
          font-size: 14px;
          color: #000000;
          font-weight: 500;
          line-height: 20px;
          margin-bottom: 8px;
          width: 180px;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
          &.docu {
            height: 40px;
            white-space: inherit;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            overflow: hidden;
            text-overflow: ellipsis;
          }
        }

        .txt2 {
          display: flex;
          justify-content: space-between;
          align-items: center;
          color: #B1B1B1;
          font-size: 12px;
          .span1 {
            width: 130px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
        }
      }
    }
    .search-none {
      position: relative;
      top: 120px;
      margin: 0 12px;
      height: 50vh;
      border-radius: 12px;
      box-sizing: border-box;
      background: #fff;

      .none-img {
        width: 185px;
        margin-left: 50%;
        transform: translateX(-50%);
        margin-top: 120px;
      }

      .none-txt {
        font-size: 12px;
        color: #949BA5;
        text-align: center;
        margin-top: 10px;
      }
    }
}
</style>



// WEBPACK FOOTER //
// src/views/article/articleList.vue